<template>
  <div class="component-content sub-content">
    <div class="list-title">
      <div class="r">
        <!--  v-if="backRole('SM_2')" -->
        <el-button type="primary" @click="addUnitBtnClick()" size="mini">新增计量单位</el-button>
      </div>
    </div>
    <el-table :data="paginationData" style="width: 100%" v-loading="loading">
      <el-table-column type="index" label="序号" align="center" width="100">
      </el-table-column>
      <!-- <el-table-column prop="code" label="代码">
      </el-table-column> -->
      <el-table-column prop="name" label="计量单位" align="center">
      </el-table-column>
      <el-table-column label="操作" width="200" align="right">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
            <i class="iconfont icon-close meeting-btn-icon mbi-remove" @click="deleteUnit(scope.row)"></i>
          </el-tooltip>
        </template>
      </el-table-column>

    </el-table>
    <el-pagination v-if="filterData.length>pageSize" class="list-pagination" background :page-size="pageSize"
      :pager-count="9" :current-page="currentPage" layout="pager" :total="filterData.length" @current-change="handleCurrentChange">
    </el-pagination>

    <!-- 添加计量单位 -->
    <div class="pop-room" v-if="addMeetingRoomStatus">
      <a href="javascript:;" @click="addMeetingRoomStatus=false" class="iconfont icon-close"></a>
      <div class="pop-cont">
        <el-col :span="22">
          <el-form ref="form" :model="form" label-width="120px" class="form" @submit.native.prevent>
            <el-form-item label="计量单位名字">
              <el-input size="small" v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-button @click="addUnit()" class="form-btn" type="success">确认提交</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </div>
    </div>

  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";
  export default {
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        addMeetingRoomStatus: false,
        form: {
          name: ""
        },

        // 列表
        loading: true,
        pageSize: 20,
        currentPage: 1,
        listData: [],
        filterData: [],
        paginationData: [],
      }
    },
    mounted() {
      this.getLists()
    },
    components: {},
    methods: {
      // 新增计量单位按钮点击
      addUnitBtnClick() {
        this.addMeetingRoomStatus = true
      },
      // 新增计量单位
      addUnit() {
        ajax.post('/storage/unit/add', this.form, (res) => {
          this.addMeetingRoomStatus = false
          this.$message.success("添加成功")
          this.getLists()
        })
      },
      // 删除计量单位
      deleteUnit(row) {
        this.$confirm('此操作将永久删除该计量单位, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          ajax.post('/storage/unit/del', {
            unitId: row.id
          }, (res) => {
            this.$message.success("删除计量单位成功")
            this.getLists()
          })
        }).catch(() => {});
      },
      // 当前页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPaginationData()
      },
      // 搜索筛选新闻数据
      getFilterData() {
        console.log(this.filterName)
        if (this.filterName) {
          // 筛选出所有符合的数据
          this.filterData = []
          for (let i = 0; i < this.listData.length; i++) {
            let _new = this.listData[i]
            if (_new.name.indexOf(this.filterName) != -1) {
              this.filterData.push(_new)
            }
          }
        } else {
          this.filterData = this.listData
        }
        this.currentPage = 1
        this.getPaginationData()
      },
      // 分页筛选数据
      getPaginationData() {
        if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
          this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
        }
        if (this.currentPage == 0) {
          this.currentPage = 1
        }
        // 分页筛选
        this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this.currentPage)
      },
      // 获取列表
      getLists() {
        this.loading = true
        ajax.get('/storage/unit/list', '', (res) => {
          this.loading = false
          this.filterData = this.listData = res.vo.array
          this.getPaginationData()
        })
      },
    },
    watch: {

    }
  };
</script>


// WEBPACK FOOTER //
// src/page/storage/unitList.vue